export const REDUCER_NAME = "nationalTeamCompetitions";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_NATIONALTEAMCOMPETITIONS = `${REDUCER_NAME}/SET_NATIONALTEAMCOMPETITIONS`;
export const RESET_NATIONALTEAMCOMPETITIONS = `${REDUCER_NAME}/RESET_NATIONALTEAMCOMPETITIONS`;
